import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { delay, filter, map, startWith, tap } from 'rxjs/operators';

import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, ActivationStart, Router, RouterOutlet } from '@angular/router';
import { Traitement } from '@app/shared/autorisations/traitements';
import { StructureService } from '@app/shared/structure/structure.service';
import { environment } from '@environments/environment';
import { LoaderService } from '../loader/loader.service';
import {
    MenuComponent,
    MenuEntryWithChildrenComponent,
    MenuEntryComponent,
    HeaderComponent,
    FooterComponent
} from '@pcscol-portail/composants-pegase';
import { MatNavList } from '@angular/material/list';
import { ShowIfAutoriseDirective } from '../../shared/autorisations/directives/show-if-autorise.directive';
import { EspaceIndicatorComponent } from '../../shared/espace-indicator/espace-indicator.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { AuthenticationFormComponent, AuthSilentComponent } from '@pcscol-portail/ng-auth';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.scss'],
    imports: [
        MenuComponent,
        MatNavList,
        ShowIfAutoriseDirective,
        MenuEntryWithChildrenComponent,
        MenuEntryComponent,
        HeaderComponent,
        EspaceIndicatorComponent,
        MatTooltip,
        MatIcon,
        AuthenticationFormComponent,
        AuthSilentComponent,
        MatProgressSpinner,
        RouterOutlet,
        FooterComponent,
        AsyncPipe
    ]
})
export class PageComponent implements OnInit {
    private structureService = inject(StructureService);
    private route = inject(ActivatedRoute);

    public version: string = environment.version;
    readonly ODF_COPIER_MAQUETTE_EXISTANT_VERS_ESPACE = Traitement.ODF_COPIER_MAQUETTE_EXISTANT_VERS_ESPACE;
    readonly ODF_IMPORTER_MAQUETTE_BASE64_VERS_ESPACE = Traitement.ODF_IMPORTER_MAQUETTE_BASE64_VERS_ESPACE;
    readonly ODF_RECHERCHER_DIPLOMES = Traitement.ODF_RECHERCHER_DIPLOMES;
    readonly ODF_RECHERCHER_ESPACES = Traitement.ODF_RECHERCHER_ESPACES;
    readonly ODF_RECHERCHER_OBJET_MAQUETTE = Traitement.ODF_RECHERCHER_OBJET_MAQUETTE;
    readonly ODF_LIRE_OBJET_MAQUETTE = Traitement.ODF_LIRE_OBJET_MAQUETTE;
    readonly ODF_LIRE_STRUCTURE_MAQUETTE = Traitement.ODF_LIRE_STRUCTURE_MAQUETTE;
    readonly ODF_RECHERCHER_ANNEES_UNIVERSITAIRES = Traitement.ODF_RECHERCHER_ANNEES_UNIVERSITAIRES;
    private readonly documentationRootUrl = '/assets/docs/user-guide.html';
    closed = false;
    structure$: Observable<string | null>;
    loading$: Observable<boolean>;
    documentationUrl$: Observable<string>;
    showEspaceSelected = false;

    @ViewChild('snav', { static: true }) private snav: MatSidenav;

    constructor() {
        const loaderService = inject(LoaderService);
        const router = inject(Router);

        this.loading$ = loaderService.loading$.pipe(startWith(false), delay(0));
        this.documentationUrl$ = router.events.pipe(
            filter(event => event instanceof ActivationStart),
            map(event => event as ActivationStart),
            tap(event => {
                this.showEspaceSelected = !!event.snapshot.data['showEspaceSelected'];
            }),
            map(event => {
                const doc = event.snapshot.data['doc'];
                return doc ? `${this.documentationRootUrl}#${doc}` : this.documentationRootUrl;
            })
        );
    }

    ngOnInit() {
        // this.snav.open();
        /* Responsive Menu */
        this.closed = window.innerWidth < 750 ? true : this.closed;

        /* Récupération de l'établissement selectionné */
        // on recupere le code structure depuis le store
        this.structure$ = this.structureService.current$;
    }

    toggle() {
        this.closed = !this.closed;
    }

    onResize(event) {
        this.closed = event.target.innerWidth < 750 ? true : this.closed;
    }
}
